import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";

export default function Terms() {
  return (
    <div className="min-h-screen navy-glow flex flex-col" data-testid="terms-page">
      <Navbar variant="public" />
      <main className="flex-1">
        <section className="max-w-4xl mx-auto px-6 py-16">
          <div className="chip mb-6">Legal · Effective 2026</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
            Terms of <span className="text-brand">Service</span>
          </h1>
          <p className="text-slate-400 mt-3">Last updated: February 2026</p>

          <div className="soft-card p-8 md:p-10 mt-10 space-y-8 text-slate-700 leading-relaxed">
            <Section title="1. Acceptance">
              By creating an account or booking a session with Yonsii Geek Support (“Yonsii”), you agree to these Terms
              of Service. If you do not agree, please do not use the service.
            </Section>

            <Section title="2. What we do">
              Yonsii provides on-demand technical support sessions delivered remotely or, where the service area
              permits, in person. Sessions cover issues like software fixes, hardware troubleshooting, virus removal,
              Wi-Fi setup, cloud backup configuration, and performance optimisation.
            </Section>

            <Section title="3. Booking, cancellation & pricing">
              <ul className="list-disc pl-5 space-y-2">
                <li>Standard sessions are priced at ₹599 (flat). Complex repairs like Speed Up & Optimize are quoted on assessment (starting from ₹599). Cloud Backup Setup is ₹799.</li>
                <li>You may cancel a scheduled session for free before the technician joins. Once a session is in progress it cannot be cancelled.</li>
                <li>If a technician cannot resolve your issue, the session is not marked completed and you are not charged.</li>
              </ul>
            </Section>

            <Section title="4. Your responsibilities">
              <ul className="list-disc pl-5 space-y-2">
                <li>Provide accurate contact details and be reachable at the scheduled time.</li>
                <li>Grant our technician the access required to fix your issue (e.g., screen share, local admin rights) — and revoke that access after the session ends.</li>
                <li>Back up important data before a repair session where possible. See our Privacy Policy for how we handle backup work.</li>
              </ul>
            </Section>

            <Section title="5. Tech-support standards">
              We commit to the four Yonsii rules on every session: identify ourselves, never ask for banking passwords or
              OTPs, never install software without your consent, and always hand you a written case log.
            </Section>

            <Section title="6. Backup & data rules">
              For cloud-backup configuration, the technician works inside <em>your</em> Google, Apple, or Microsoft
              account. We never copy your files to Yonsii servers. You remain the sole owner of every file, folder, and
              backup we help set up. You are responsible for keeping your cloud account credentials safe after the session.
            </Section>

            <Section title="7. Limitation of liability">
              To the maximum extent permitted by law, Yonsii's total liability for any claim arising out of a session is
              limited to the amount you paid for that session. We are not liable for (a) pre-existing hardware failure,
              (b) data loss that occurred before we began work, (c) third-party service outages (ISPs, cloud providers,
              OS vendors), or (d) indirect, incidental, or consequential damages. Our recommendations are best-effort and
              you retain final decision-making authority over your device.
            </Section>

            <Section title="8. Prohibited use">
              You may not use Yonsii to attempt illegal activity, extract data from accounts you don't own, bypass
              digital-rights protections, or harass our technicians. We may refuse or terminate a session that violates
              these rules.
            </Section>

            <Section title="9. Refunds">
              A session that we mark completed is not refundable. A session that fails (technician cannot resolve, or you
              cancel before start) is not charged. Disputes must be raised within 14 days at hello@yonsiigeeksupport.com.
            </Section>

            <Section title="10. Changes">
              We may update these Terms as our service evolves. Material changes will be communicated by email or a
              notice on the dashboard. Continued use after the effective date means you accept the updated Terms.
            </Section>

            <Section title="11. Governing law">
              These Terms are governed by the laws of India. Disputes will be resolved in the courts of Delhi.
            </Section>

            <Section title="12. Contact">
              Yonsii Geek Support · Dwarka, Delhi, India · hello@yonsiigeeksupport.com
            </Section>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl font-extrabold text-slate-900 mb-3">{title}</h2>
      <div className="space-y-3 text-[15px]">{children}</div>
    </div>
  );
}
